/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfAanmeldValidationResult } from '../../models/platform-api-result-of-aanmeld-validation-result';
import { PlatformValidateEmailAndPassword } from '../../models/platform-validate-email-and-password';

export interface PostUseraccountsActionValidateemailandpassword$Params {
      body: PlatformValidateEmailAndPassword
}

export function postUseraccountsActionValidateemailandpassword(http: HttpClient, rootUrl: string, params: PostUseraccountsActionValidateemailandpassword$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAanmeldValidationResult>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionValidateemailandpassword.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfAanmeldValidationResult>;
    })
  );
}

postUseraccountsActionValidateemailandpassword.PATH = '/api/useraccounts/action/validateemailandpassword';
